export const FacebookPageShareUrlWay = {
    SplashUrl: "SplashUrl",
    EventUrl: "EventUrl",
    CustomUrl: "CustomUrl"
}


// WEBPACK FOOTER //
// ./src/consts/FacebookPageShareUrlWay.ts